import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { config } from "@config";

@Component({
	selector: "app-uk-risk-summary",
	templateUrl: "./uk-risk-summary.component.html",
	styleUrls: ["./uk-risk-summary.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class UkRiskSummaryComponent {
	@Input() public classes: string | string[];
	@Input() titleKey?: string = "uk_finprom_risk_summary_title";
	@Input() summaryKey?: string = "uk_finprom_risk_summary_text";

	getUrl(): string {
		return config.baseUrl + config.externalPaths["uk_finprom_risk_summary"]["link"];
	}
}
